import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category/latest' },
  { label: '精品推荐', href: '/category/featured' },
  { label: '会员专区', href: '/category/members' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 no-underline" aria-label="蜜桃传媒首页">
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-play-circle-fill text-background-50 text-xl"></i>
          </div>
          <span className={`font-heading text-lg font-bold transition-colors duration-300 ${
            scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
          }`}>
            蜜桃传媒
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = link.href === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(link.href);
            return (
              <Link
                key={link.href}
                to={link.href}
                className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 relative py-1 ${
                  scrolled || !isHome
                    ? isActive
                      ? 'text-primary-500'
                      : 'text-foreground-600 hover:text-foreground-950'
                    : isActive
                      ? 'text-background-50'
                      : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {link.label}
                {isActive && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-0.5 rounded-full bg-primary-500" />
                )}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/category/members"
            className="whitespace-nowrap px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            加入会员
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 shadow-sm">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = link.href === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? 'bg-primary-100 text-primary-600'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/category/members"
              className="mt-2 px-3 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors duration-200"
            >
              加入会员
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}